import React, {FC} from 'react';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {ButtonVariantsEnum} from '../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {OkCancelDialog} from '../../../../libs/shared/ui/src/components/dialogs/okCancelDialog';

/*
 * Props.
 */

interface DismissSetupGuideDialogProps {
  onClose: () => void;
  onOkClick: () => void;
}

/*
 * Component.
 */

export const DismissSetupGuideDialog: FC<DismissSetupGuideDialogProps> = (props) => {
  const {onClose, onOkClick} = props;

  return (
    <OkCancelDialog
      okButtonVariant={ButtonVariantsEnum.DANGER}
      title={<Trans id="setup-guide-dismiss-permanently-dialog-title">Dismiss setup guide</Trans>}
      okButtonLabel={<Trans id="setup-guide-dismiss-permanently-dialog-confirm">Delete</Trans>}
      onRequestClose={onClose}
      onOkClick={onOkClick}
    >
      <Trans id="setup-guide-dismiss-permanently-dialog-content">
        This will permanently remove the setup guide for you. This action cannot be undone.
      </Trans>
    </OkCancelDialog>
  );
};
